<template>
  <v-card v-if="visibleLayers.length" width="260" class="map-layer-legend" outlined>
    <v-expansion-panels>
      <v-expansion-panel v-for="layer in visibleLayers" :key="layer.id">
        <v-expansion-panel-header class="py-1">
          <div class="d-flex align-center flex-wrap">
            <span class="text-caption font-weight-medium mr-2">{{ layer.name }}</span>
            <span
              v-for="(color, category) in previewColors(layer)"
              :key="category"
              class="legend-dot"
              :style="{ backgroundColor: color }"
            ></span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-if="layer.categories" class="mb-2">
            <p class="text-overline mb-1">Category</p>
            <v-chip-group
              :value="activeFilter(layer.id).category"
              @change="(v) => setFilter(layer.id, 'category', v)"
              column
            >
              <v-chip small :value="null">All</v-chip>
              <v-chip
                v-for="(color, category) in layer.categories"
                :key="category"
                small
                :value="category"
              >
                <span class="legend-dot mr-1" :style="{ backgroundColor: color }"></span>
                {{ category }}
              </v-chip>
            </v-chip-group>
          </div>
          <div v-if="layer.categoriesSecondary">
            <p class="text-overline mb-1">Secondary category</p>
            <v-chip-group
              :value="activeFilter(layer.id).categorySecondary"
              @change="(v) => setFilter(layer.id, 'categorySecondary', v)"
              column
            >
              <v-chip small :value="null">All</v-chip>
              <v-chip
                v-for="(color, category) in layer.categoriesSecondary"
                :key="category"
                small
                :value="category"
              >
                <span class="legend-dot mr-1" :style="{ backgroundColor: color }"></span>
                {{ category }}
              </v-chip>
            </v-chip-group>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
export default {
  name: "MapLayerLegendPanel",
  props: {
    layers: { type: Array, required: false, default: () => [] },
    value: { type: Object, required: false, default: () => ({}) },
  },
  computed: {
    visibleLayers() {
      return this.layers.filter((layer) => layer.visible !== false);
    },
  },
  methods: {
    previewColors(layer) {
      return Object.fromEntries(Object.entries(layer.categories || {}).slice(0, 4));
    },
    activeFilter(layerId) {
      return this.value[layerId] || { category: null, categorySecondary: null };
    },
    setFilter(layerId, key, val) {
      this.$emit("input", {
        ...this.value,
        [layerId]: { ...this.activeFilter(layerId), [key]: val },
      });
    },
  },
};
</script>

<style scoped>
.map-layer-legend {
  max-height: 60vh;
  overflow-y: auto;
}
.legend-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 2px;
}
</style>
